import { API_END_POINTS } from "../../constant/config";
import axios from 'axios';
import { GET_MARKETING_MATERIAL_BANNER } from "../types";

export const getMarketingMaterialBanner = () => async (dispatch) => {
  try {
        const apiEndpoint = API_END_POINTS.GET_MARKETING_BANNERS;
        const response = await axios.get(apiEndpoint)
        
        dispatch({
            type: GET_MARKETING_MATERIAL_BANNER,
            payload: response.data.data,
        });
  } catch (error) {
      console.log("error", error);
  }
};

export const getHomePageBanners = () => async (dispatch) => {
  try {
        const apiEndpoint = API_END_POINTS.FETCH_HOME_PAGE_BANNERS;
        const response = await axios.get(apiEndpoint)
        
        return dispatch({
            type: "GET_HOME_PAGE_BANNERS",
            payload: response.data.data,
        });
  } catch (error) {
      console.log("error", error);
  }
};
